import React from "react";

function Music() {
  return (
    <div className="container py-5" style={{ marginTop: 100 }}>
      <h2 className="mb-4 text-white">Music</h2>
      <p>Check out our exclusive tracks! Use the play button in the header to listen.</p>
      {/* Optionally, add streaming platform links or music embeds here */}
    </div>
  );
}
export default Music;
